import { inject, Component } from '@angular/core';

import { MessageService } from '../message.service';

@Component({
    selector: 'app-messages',
    templateUrl: './messages.component.html',
    styleUrls: ['./messages.component.scss'],
    standalone: true
})
export class MessagesComponent {

  public messageService: MessageService = inject(MessageService);

}
